import { useContext } from "react";
import { SelectChangeEvent } from "@mui/material";
import { InputSelectV2 } from "components/ui/inputSelectV2";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { TipoFirmanteProps } from "../interfaces/firmaInterfaces";

export const TipoFirmante = ({
  className = "",
  ...props
}: TipoFirmanteProps) => {
  const { addTipoFirmante } = useContext(FirmaElectronicaContext);

  const handleChangeTipoFirmante = (e: SelectChangeEvent<string>) => {
    addTipoFirmante(Number(e.target.value));
  };

  return (
    <InputSelectV2
      name="tipo_firmante"
      label="Tipo Firmante"
      optionLabel="label"
      optionValue="value"
      options={[
        { label: "Abogado Externo", value: 1 },
        { label: "Interesado", value: 2 },
      ]}
      onChange={(e: SelectChangeEvent<string>) => handleChangeTipoFirmante(e)}
      className={className}
      {...props}
    />
  );
};
